export default __webpack_public_path__ + "static/media/hht2_ep18_timeline_q03_b.cada627c.png";